import React from 'react';
import { Field } from 'api/tasks';
import {
  FieldDataType,
  FieldType,
} from 'components/organisms/module-settings/fields/types';
import {
  CpTdBooleanField,
  CpTdDateField,
  CpTdMultiLineTextField,
  CpTdMultiSelectField,
  CpTdMultiUserField,
  CpTdNumberField,
  CpTdSingleSelectField,
  CpTdSingleUserField,
  CpTdTextField,
} from './cp-td-task-field-editors';

export const FieldValueEditor: React.FC<{
  field: Field;
  onChange: (va: unknown) => void;
}> = ({ field, onChange }) => {
  const type: `${FieldType}__${FieldDataType}` = `${
    field?.fieldType as FieldType
  }__${field?.fieldDataType as FieldDataType}`;

  switch (type) {
    case 'SINGLE_SELECT__TEXT': {
      if (field?.optionsAvailable) {
        return <CpTdSingleSelectField field={field} onChange={onChange} />;
      }

      return <CpTdTextField field={field} onChange={onChange} />;
    }
    case 'SINGLE_SELECT__NUMBER': {
      if (field?.optionsAvailable) {
        return <CpTdSingleSelectField field={field} onChange={onChange} />;
      }

      return <CpTdNumberField field={field} onChange={onChange} />;
    }

    case 'SINGLE_SELECT__MULTI_LINE_TEXT':
      return <CpTdMultiLineTextField field={field} onChange={onChange} />;

    case 'MULTI_SELECT__TEXT':
    case 'MULTI_SELECT__NUMBER': {
      if (field?.optionsAvailable) {
        return <CpTdMultiSelectField field={field} onChange={onChange} />;
      }

      return <></>;
    }

    case 'SINGLE_SELECT__USER':
      return <CpTdSingleUserField field={field} onChange={onChange} />;

    case 'MULTI_SELECT__USER':
      return <CpTdMultiUserField field={field} onChange={onChange} />;

    case 'SINGLE_SELECT__DATE':
      return <CpTdDateField field={field} onChange={onChange} />;

    case 'SINGLE_SELECT__BOOLEAN':
      return <CpTdBooleanField field={field} onChange={onChange} />;

    case 'MULTI_SELECT__BOOLEAN':
    case 'MULTI_SELECT__DATE':
    case 'MULTI_SELECT__MULTI_LINE_TEXT':
    default:
      return <></>;
  }

  return <></>;
};
